import dangerIpDialog from './index.vue';
 
// 定义插件对象
const DangerIpDialog = {};
// vue的install方法，用于定义vue插件
DangerIpDialog.install = function (Vue, options) {
  const DangerIpDialogInstance = Vue.extend(dangerIpDialog);
  let currentMsg;
  const initInstance = () => {
    // 实例化vue实例
    currentMsg = new DangerIpDialogInstance();
    let msgBoxEl = currentMsg.$mount().$el;
    document.body.appendChild(msgBoxEl);
  };
  // 在Vue的原型上添加实例方法，以全局调用
  Vue.prototype.$dangerIpDialog = {
    showDangerIpDialog (options) {
      if (!currentMsg) {
        initInstance();
      }
      if (typeof options === 'string') {
        currentMsg.content = options;
      } else if (typeof options === 'object') {
        Object.assign(currentMsg, options);
      }
      currentMsg.showMsgBox();
    }
  };
};
 
export default DangerIpDialog;


// WEBPACK FOOTER //
// ./src/components/common/danger-ip-dialog/index.js